// src/app/core/interceptor/socket.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SocketService } from '../service/socket.service';

export const socketInterceptor: HttpInterceptorFn = (req, next) => {
    const socketService = inject(SocketService);

    // Add socket ID to specific requests if needed
    if (req.url.includes('/user/register-vendor-socket')) {
        const socketId = socketService.getSocketId();
        if (socketId) {
            req = req.clone({
                body: {
                    ...(req.body as any),
                    socket_id: socketId,
                },
            });
        }
    }

    return next(req);
};
